import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import { Tooltip } from 'react-tooltip';

import bear from '../assets/bear_emoji.png';
import arrow from '../assets/enter_arrow.png';
import skip from '../assets/skip_arrow.png';

import Background from '../components/Background';

const Login = () => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (password === 'hello world!') {
            navigate('/homepage');
        } else {
            setError(true);
            setPassword('');
        }
    }

    const handleSkip = () => {
        navigate('/homepage');
    };

    return (
        <div>
            <Background />
            <div className="main-container">
            {/* Logo */}
            <div className="logo">CSHEN.</div>

            {/* Login Form */}
            <div className="login-container">
                <div className="profile">
                    <img src={bear} alt="bear emoji icon" className="profile-icon" />
                </div>
                <h2 className="username">Celina Shen</h2>
                    <div className="password-container">
                        <form className={`login-form ${error ? 'shake' : ''}`} onSubmit={handleSubmit}>
                        <input 
                            type="password"
                            placeholder="Enter Password"
                            className="password-input"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError(false);
                            }}
                        />
                        <button type="submit" className="login-button">
                            <img src={arrow} alt="enter button" className="login-arrow" />
                        </button>
                    </form>
                    <div 
                        className="help-icon"
                        data-tooltip-id="help"
                        data-tooltip-content="Hint: print('hello world!')"
                        data-tooltip-place="right"
                    >?</div>
                    <Tooltip id="help" className="help-tooltip"/>
                </div>
            </div>

            {/* Skip button */}
            <div className="skip-container">
                <button className="skip-button" onClick={handleSkip}>
                    <img src={skip} alt="skip icon" className="skip-icon" />
                </button>
                <p className="skip-text">Skip</p>
            </div>
        </div>
    </div>
    );
};

export default Login;
